namespace $.$$ {
	$mol_style_define( $shm_hitalama_projects_map, {
		flex: { grow: 1, shrink: 0, basis: '40rem' },
		minWidth: 0, maxWidth: '100%',
		background: { color: $mol_theme.back },
		Book: {
			// Floating map tools use viewport coordinates. Layout containment here
			// would make this nested book their containing block a second time.
			contain: 'style',
			position: 'relative',
		},
	})
}
